import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { getStaticFileUrl } from "../utils/config";

interface OurValuesData {
  imageUrl: string;
}

export const OurValues: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [ourValuesData, setOurValuesData] = useState<OurValuesData>({
    imageUrl: '/img/about/ourvalues.png',
  });

  useEffect(() => {
    // API에서 Our Values 데이터 불러오기
    const loadOurValuesData = async () => {
      try {
        const { contentApi } = await import('../services/api');
        const data = await contentApi.get('our-values');
        if (data && Array.isArray(data) && data.length > 0) {
          const ourValuesInfo = data[0];
          setOurValuesData({
            imageUrl: ourValuesInfo.imageUrl || ourValuesData.imageUrl,
          });
        }
      } catch (error) {
        console.error('Our Values 데이터 로드 실패:', error);
      }
    };

    loadOurValuesData();
  }, []);
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        height: isMobile ? "40vh" : "80vh",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "rgb(0, 0, 0)",
        overflow: "hidden",
        backgroundColor: "#f5f5f5", // 배경색 변경
      }}
    >
      <Box
        component="header"
        sx={{
          width: isMobile ? "80vw" : "50vw",
          height: isMobile ? "80vh" : "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundSize: "contain", // 원본 비율 유지
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${getStaticFileUrl(ourValuesData.imageUrl)})`,
        }}
      ></Box>
    </Box>
  );
};
